// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"boardLane_mulitpleDropdown__3iFfG","laneHeader":"boardLane_laneHeader__3OWuS"};